import React, { ForwardedRef, forwardRef, useImperativeHandle } from 'react';

import ProductAdderRoot from '@src/components/Product/ProductAdderRoot';
import ProductPackageAdderRoot from '@src/components/ProductPackage/ProductPackageAdderRoot';
import usePackageIdParam from '@src/hooks/usePackageIdParam';
import { useAppDispatch } from '@src/core/hooks';
import { toggleIsClosingAdderModal } from '@src/features/product';
import useSelectedProductId from '@src/hooks/useSelectedProductId';
import { useWidgetId } from '@src/core/IdProvider';

type AdderRootContainerRef = () => void | undefined;

const AdderRootContainer = forwardRef((_, ref: ForwardedRef<AdderRootContainerRef>) => {
  const packageId = usePackageIdParam();
  const dispatch = useAppDispatch();
  const productId = useSelectedProductId();
  const widgetId = useWidgetId();

  useImperativeHandle(
    ref,
    () => () => {
      if (productId && packageId) {
        dispatch(toggleIsClosingAdderModal(widgetId, true));
      }
    },
    [productId, dispatch, packageId],
  );

  return packageId ? <ProductPackageAdderRoot /> : <ProductAdderRoot />;
});

AdderRootContainer.displayName = 'AdderRootContainer';

export default AdderRootContainer;
